import { lazy } from "react";

import AppIcons from "../../../components/Base/AppIcons";
import { listPermissionsModuleDevoluciones } from "./listPermissionsModuleDevoluciones";
const ViewsDevoluciones = lazy(() => import("./views/ViewsDevoluciones"));

const routesModuleDevoluciones = {
  link: "/module-pasarela-oats-tramite-pay-module-devoluciones/:pk_id_convenio",
  label: (
    <AppIcons
      Logo={"RECARGA_CELULAR"}
      name="Retiro Directo Asignación Por QR"
    />
  ),
  component: ViewsDevoluciones,
  permission: [...listPermissionsModuleDevoluciones],
  subRoutes: [],
  show: false,
};

export default routesModuleDevoluciones;
